import * as types from './mutation-types'
import { MutationTree } from 'vuex'
import BrandState from '../types/BrandsState'

export const mutations: MutationTree<BrandState> = {
  [types.ALL_BRANDS] (state, brands) {
    state.brands = brands
  }
}
